import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import { router } from './router';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
// You also need to import the styles. If you're using webpack's css-loader, you can do so here:
import 'vue-snotify/styles/material.css'; // or dark.css or simple.css

Vue.config.productionTip = false;
Vue.prototype.$IsLogged = sessionStorage.length > 0;

const options = {
    toast: {
        position: SnotifyPosition.rightTop
    }
};

Vue.use(Snotify, options);
Vue.use(Chartkick.use(Chart));

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount("#app");
